import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FiCheck } from 'react-icons/fi';
import { firestore } from '../../../config/firebase';
import { createInventory } from '../../../store/actions/inventoryActions';
import Swal from 'sweetalert2';
import Scanner from './Scanner';
import './NewInventory.css';
import lang from '../lang';

class NewInventory extends Component {
    state = {
        inventoryList: [],
        totalItems: 0,
        remainingItems: 0,
        createdAt: Date.now(),
        updatedAt: Date.now(),
        activeRow: '',
        scanner: true
    }

    componentDidMount() {
        const { products } = this.props;

        const totalItems = products.reduce((total, item) => total += item.piece, 0)
        this.setState({
            totalItems,
            remainingItems: totalItems,
            inventoryList: products.filter(item => {
                if (item.piece > 0) {
                    item.inStock = item.piece
                    return item;
                }
            }),
        });


    }

    checkStatusHandler = (id) => {
        this.setState(prevState => {
            return {
                inventoryList: prevState.inventoryList.filter(item => item.id !== id),
                remainingItems: prevState.remainingItems - prevState.inventoryList.find(item => item.id === id).piece
            }
        });

    }

    pieceChangeHandler = (id, type) => {
        const updateData = this.state.inventoryList.find(item => item.id === id);

        if (updateData) {
            if (updateData.piece > 0) {
                if (type === 'decrement') {
                    let isEqualZero = 0; // Check after updating the value is 0 
                    this.setState(prevState => {
                        return {
                            inventoryList: prevState.inventoryList.map((item) => {
                                if (item.id === id) {
                                    isEqualZero = Object.assign({}, { count: item.piece - 1 });
                                    item.piece--;
                                }
                                return item;
                            }),
                            remainingItems: prevState.remainingItems - 1,
                            activeRow: id
                        }
                    }, () => {
                        // If value is 0 then remove the item from list
                        if (isEqualZero.count === 0) {
                            this.removeItemHandler(id)
                        }
                    })

                } else {
                    this.setState(prevState => {
                        let incrementable = true;
                        return {
                            inventoryList: prevState.inventoryList.map((item) => {
                                incrementable = item.piece < item.inStock
                                if (item.id === id && incrementable) {
                                    item.piece++;
                                }
                                return item;
                            }),
                            remainingItems: incrementable ? prevState.remainingItems + 1 : prevState.remainingItems,
                            activeRow: id
                        }
                    })
                }
            } else {
                return this.setState({
                    inventoryList: this.state.inventoryList.filter(item => item.id !== id),
                    activeRow: id
                });
            }
        } else {
            Swal.fire({
                type: 'error',
                title: 'No item',
                text: 'Sorry, the item is not in the list',
                timer: 1500
            });
        }

    }

    removeItemHandler = (id) => {
        this[id + 'Ref'].classList.add('table-success')
        setTimeout(() => {
            this.setState(prevState => {
                return {
                    inventoryList: prevState.inventoryList.filter(item => item.id !== id)
                }
            })
        }, 1000)
    }

    resulthandler = () => {
        const { remainingItems, inventoryList, totalItems } = this.state;
        const data = {
            totalItems,
            remainingItems,
            missingItems: remainingItems > 0 ? remainingItems : 0,
            extraItems: this.state.extraItems || 0,
            status: remainingItems === 0 ? 'success' : 'danger',
            remainingItemsList: inventoryList,
            createdAt: Date.now(),
            updatedAt: Date.now()
        }

        firestore.collection('users')
            .doc(this.props.user.id)
            .collection('inventory')
            .add(data)
            .then(doc => {
                this.props.createInventory({ ...data, id: doc.id });
                Swal.fire({
                    type: 'success',
                    title: lang[this.props.user.lang].newIn.msg,
                    showConfirmButton: false,
                    timer: 1500
                });
                setTimeout(() => {
                    this.props.history.push('/inventory-count');
                }, 2000)
            })
    }

    render() {
        const { newIn: { title, total, name, code, size, quantity, check, show, hide, subTitle, subQuantity, save } } = lang[this.props.user.lang || 'uz']
        return (
            <div id="create-inventory-list">
                <div className="d-flex my-3">
                    <h2 className="mr-auto">{title}</h2>
                    <div>
                        <span className="badge badge-success badge-pill">{total}: {this.state.totalItems}</span> - <span className="badge badge-danger badge-pill"> {total}: {this.state.remainingItems}</span>
                    </div>
                </div>

                <div className="d-flex flex-column flex-lg-row">
                    <div className="bg-white border" id="new-inventory-list">
                        <table className="table table-bordered text-center" id="inventory-count-table">
                            <thead className="thead-dark">
                                <tr>
                                    <th>#</th>
                                    <th>{name}</th>
                                    <th>{code}</th>
                                    <th>{size}</th>
                                    <th>{quantity}</th>
                                    <th>{check}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.state.inventoryList.map((item, i) => {
                                        return (
                                            <tr
                                                key={item.id}
                                                ref={ref => this[item.id + 'Ref'] = ref}
                                                className={`${this.state.activeRow === item.id ? 'table-primary' : ''}`}
                                            >
                                                <td>{i + 1}</td>
                                                <td>{item.name}</td>
                                                <td>{item.code}</td>
                                                <td>{item.dimensions}</td>
                                                <td className="inventory-pieces">
                                                    <button className="btn btn-sm btn-primary" onClick={(id, type) => this.pieceChangeHandler(item.id, 'decrement')}>-</button>
                                                    <span className="display-piece">{item.piece}</span>
                                                    <button
                                                        className={`btn btn-sm btn-primary ${item.piece <= item.inStock ? '' : ''}`}
                                                        onClick={(id, type) => this.pieceChangeHandler(item.id, 'increment')}
                                                    >+</button>
                                                </td>
                                                <td><button className="btn btn-sm btn-outline-success inventory-status" onClick={() => this.checkStatusHandler(item.id)}><FiCheck /></button></td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                    <div className="text-center bg-white border" id="new-inventory-scanner">

                        <div>
                            {this.state.scanner && <Scanner removeItem={this.pieceChangeHandler} />}
                        </div>
                        <button
                            className="btn btn-sm btn-primary mb-4"
                            onClick={() => this.setState(prevState => ({ scanner: !prevState.scanner }))}
                        >{this.state.scanner ? hide : show}</button>
                    </div>


                </div>
                <div className="text-center">
                    <h4 className="mt-4">{subTitle}</h4>
                    <div className="input-group my-4 mx-auto w-75">
                        <div className="input-group-prepend">
                            <span className="input-group-text">{subQuantity}</span>
                        </div>
                        <input
                            type="number"
                            className="form-control"
                            name="extraItems"
                            onChange={(e) => this.setState({ extraItems: e.target.value })}
                        />
                    </div>
                    <button className="btn btn-success btn-lg px-5" onClick={this.resulthandler}>{save}</button>
                </div>

            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        products: state.products.products,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        createInventory: (data) => dispatch(createInventory(data))
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NewInventory));